import React from "react";

import logo from "../assets/images/logo.png";

export default function LoadingScreen() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-slate-950 px-6 text-center text-white">
      <img className="w-40" src={logo} alt="MB Floripa Turismo" />
      <p className="text-lg font-medium text-white/70">
        Carregando sua próxima viagem...
      </p>
      <div className="flex w-48 overflow-hidden rounded-full bg-white/10">
        <div className="h-2 w-1/2 animate-pulse rounded-full bg-primary" />
      </div>
    </div>
  );
}
